import { SITE_CONFIG } from "../config";

const GA_ID = process.env.REACT_APP_GA_ID || "";

export function trackEvent(action, category, label, value) {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
}

export function trackConversion(conversionType, details = {}) {
  trackEvent(conversionType, "conversion", details.label || conversionType, details.value);
}

export function trackWhatsAppClick(source) {
  trackConversion("whatsapp_click", { label: source });
}

export function trackCTAClick(ctaName, destination) {
  trackConversion("cta_click", { label: `${ctaName}_${destination}` });
}

export function trackFormSubmission(formName) {
  trackConversion("form_submit", { label: formName });
}

export function getWhatsAppURL(message) {
  const msg = message || SITE_CONFIG.whatsapp.defaultMessage;
  return `https://wa.me/${SITE_CONFIG.whatsapp.number}?text=${encodeURIComponent(msg)}`;
}

export function openWhatsApp(message, source = "unknown") {
  trackWhatsAppClick(source);
  window.open(getWhatsAppURL(message), "_blank");
}
